
import React, { Component } from "react";
import { Feedback, Button } from "@alife/next";

export default class CountdownButton extends Component {
  constructor(props) {
    super(props);

    this.state = {
      counting: false,
      seconds: 60,
    };

    this.handleClick = this.handleClick.bind(this);

  }
  componentDidUpdate(prevProps, prevState) {
    //console.log(this.state.counting, prevState.counting);
    if (this.state.counting && !prevState.counting) {
      this.startCountdown();
    }

    if (this.state.seconds <= 0 && prevState.seconds > 0) {
      this.stopCountdown();
      this.setState({ counting: false });
  }
  }

  startCountdown() {
    this.timer = setInterval(() => {
      this.setState((prevState) => ({
        seconds: prevState.seconds - 1
      }));
  }, 1000);
  }

  stopCountdown() {
    clearInterval(this.timer);
    this.timer = null;
  }

  sendCode() {
    const { buttonClick } = this.props;

    // 这里应该调用实际发送验证码的API
    //console.log('Sending verification code...');
    this.setState({
      counting: true,
      seconds: 60
    });
    buttonClick();
};

  handleClick() {
    let { counting, seconds } = this.state;
    if (!counting) {
      this.sendCode();
    } else {
        Feedback.toast.show({
            type: "prompt",
            content: '请等待' + seconds + '秒后再试'
        });
    }
  };

  componentWillUnmount() {
    clearInterval(this.timer);
  }

  render() {
    const { counting, seconds } = this.state;

    return (
      <Button
        // type={counting ? 'disabled' : 'primary'}
        type={'primary'}
        className="sms_code_button"
        onClick={this.handleClick}
        style={{
            backgroundColor: '#fff',
            color: '#fe6000'
        }}
      >
        {counting && `重新发送(${seconds}s)`}
        {!counting && '获取验证码'}
      </Button>
    );

  }
}
